var _slicedToArray = require("/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/slicedToArray.js").default;

!function webpackUniversalModuleDefinition(e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == typeof exports ? exports["@wordpress/viewport"] = t() : (e.wp = e.wp || {}, e.wp.viewport = t());
}(self, function () {
  return function () {
    var e = {
      221: function _(e) {
        function _extends() {
          return e.exports = _extends = Object.assign || function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var r = arguments[t];

              for (var o in r) {
                Object.prototype.hasOwnProperty.call(r, o) && (e[o] = r[o]);
              }
            }

            return e;
          }, e.exports.__esModule = !0, e.exports.default = e.exports, _extends.apply(this, arguments);
        }

        e.exports = _extends, e.exports.__esModule = !0, e.exports.default = e.exports;
      },
      424: function _(e) {
        e.exports = function _interopRequireDefault(e) {
          return e && e.__esModule ? e : {
            default: e
          };
        }, e.exports.__esModule = !0, e.exports.default = e.exports;
      },
      243: function _(e, t, r) {
        "use strict";

        var o = r(424);
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.default = void 0;
        var i = r(200),
            u = o(r(137));

        var _default = function _default(e) {
          return (0, i.createHigherOrderComponent)((0, i.compose)([(0, u.default)({
            isViewportMatch: e
          }), (0, i.ifCondition)(function (e) {
            return e.isViewportMatch;
          })]), "ifViewportMatches");
        };

        t.default = _default;
      },
      451: function _(e, t, r) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.default = void 0;
        var o = r(793),
            i = r(467),
            u = r(698);

        var _default = function _default(e, t) {
          var r = (0, o.debounce)(function () {
            var e = (0, o.mapValues)(n, function (e) {
              return e.matches;
            });
            (0, i.dispatch)(u.store).setIsMatching(e);
          }, {
            leading: !0
          }),
              n = (0, o.reduce)(e, function (e, i, u) {
            return (0, o.forEach)(t, function (t, o) {
              var n = window.matchMedia("(".concat(t, ": ").concat(i, "px)"));
              n.addListener(r);
              var a = [o, u].join(" ");
              e[a] = n;
            }), e;
          }, {});
          window.addEventListener("orientationchange", r), r(), r.flush();
        };

        t.default = _default;
      },
      360: function _(e, t) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.setIsMatching = function setIsMatching(e) {
          return {
            type: "SET_IS_MATCHING",
            values: e
          };
        };
      },
      698: function _(e, t, r) {
        "use strict";

        var o = r(424);
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.store = void 0;

        var i = r(467),
            u = o(r(866)),
            n = _interopRequireWildcard(r(360)),
            a = _interopRequireWildcard(r(356));

        function _getRequireWildcardCache(e) {
          if ("function" != typeof WeakMap) return null;
          var t = new WeakMap(),
              r = new WeakMap();
          return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
            return e ? r : t;
          })(e);
        }

        function _interopRequireWildcard(e, t) {
          if (!t && e && e.__esModule) return e;
          if (null === e || "object" != typeof e && "function" != typeof e) return {
            default: e
          };

          var r = _getRequireWildcardCache(t);

          if (r && r.has(e)) return r.get(e);
          var o = {},
              i = Object.defineProperty && Object.getOwnPropertyDescriptor;

          for (var u in e) {
            if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
              var n = i ? Object.getOwnPropertyDescriptor(e, u) : null;
              n && (n.get || n.set) ? Object.defineProperty(o, u, n) : o[u] = e[u];
            }
          }

          return o.default = e, r && r.set(e, o), o;
        }

        var s = (0, i.createReduxStore)("core/viewport", {
          reducer: u.default,
          actions: n,
          selectors: a
        });
        t.store = s, (0, i.register)(s);
      },
      866: function _(e, t) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.default = void 0;

        var r = function reducer() {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              t = arguments.length > 1 ? arguments[1] : void 0;
          return "SET_IS_MATCHING" === t.type ? t.values : e;
        };

        t.default = r;
      },
      356: function _(e, t) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.isViewportMatch = function isViewportMatch(e, t) {
          -1 === t.indexOf(" ") && (t = ">= " + t);
          return !!e[t];
        };
      },
      137: function _(e, t, r) {
        "use strict";

        var o = r(424);
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.default = void 0;
        var i = r(753),
            u = o(r(221)),
            n = r(793),
            a = r(200);

        var _default = function _default(e) {
          return (0, a.createHigherOrderComponent)(function (t) {
            return (0, a.pure)(function (r) {
              var o = (0, n.mapValues)(e, function (e) {
                var _e$split = e.split(" "),
                    _e$split2 = _slicedToArray(_e$split, 2),
                    t = _e$split2[0],
                    r = _e$split2[1];

                return void 0 === r && (r = t, t = ">="), (0, a.useViewportMatch)(r, t);
              });
              return (0, i.createElement)(t, (0, u.default)({}, r, o));
            });
          }, "withViewportMatch");
        };

        t.default = _default;
      },
      200: function _(e) {
        "use strict";

        e.exports = require("@wordpress/compose");
      },
      467: function _(e) {
        "use strict";

        e.exports = require("@wordpress/data");
      },
      753: function _(e) {
        "use strict";

        e.exports = require("@wordpress/element");
      },
      793: function _(e) {
        "use strict";

        e.exports = require("lodash");
      }
    },
        t = {};

    function __webpack_require__(r) {
      var o = t[r];
      if (void 0 !== o) return o.exports;
      var i = t[r] = {
        exports: {}
      };
      return e[r](i, i.exports, __webpack_require__), i.exports;
    }

    var r = {};
    return function () {
      "use strict";

      var e = r,
          t = __webpack_require__(424);

      Object.defineProperty(e, "__esModule", {
        value: !0
      }), Object.defineProperty(e, "ifViewportMatches", {
        enumerable: !0,
        get: function get() {
          return u.default;
        }
      }), Object.defineProperty(e, "store", {
        enumerable: !0,
        get: function get() {
          return i.store;
        }
      }), Object.defineProperty(e, "withViewportMatch", {
        enumerable: !0,
        get: function get() {
          return n.default;
        }
      });

      var o = t(__webpack_require__(451)),
          i = __webpack_require__(698),
          u = t(__webpack_require__(243)),
          n = t(__webpack_require__(137));

      (0, o.default)({
        huge: 1440,
        wide: 1280,
        large: 960,
        medium: 782,
        small: 600,
        mobile: 480
      }, {
        "<": "max-width",
        ">=": "min-width"
      });
    }(), r;
  }();
});